import type { TCreateSlice } from "@/store";

type TActionsPublicUserConsent = {
    setUserConsentChecked: (consent: boolean) => void;
};

export type TSliceUserConsent = TStateUserConsent & TActionsPublicUserConsent;

export type TStateUserConsent = {
    userConsentChecked: boolean;
};

export const initialStateUserConsent: TStateUserConsent = {
    userConsentChecked: false,
};

export const createSliceUserConsent: TCreateSlice<
    TSliceUserConsent,
    Record<string, never>
> = () => set => {
    const actionsPublic: TActionsPublicUserConsent = {
        setUserConsentChecked: (consent: boolean) => {
            set(
                {
                    userConsentChecked: consent,
                },
                false,
                "userConsent/setUserConsentChecked",
            );
        },
    };

    return {
        ...initialStateUserConsent,
        ...actionsPublic,
    };
};
